import { configureStore } from '@reduxjs/toolkit'
import { enableBatching } from 'redux-batched-actions'

// Middlewares required by SkyBase UI.
import { redirectMiddleware } from '@kistler/skybase-ui/skybase-core/middlewares/redirect-middleware'
import { localeMiddleware } from '@kistler/skybase-ui/skybase-core/locales/middlewares'
import { loggerMiddleware } from '@/middlewares'
import { downloadFileMiddleware } from '@kistler/skybase-ui/skybase-core/middlewares/download-file-middleware'
import { oauthMiddleware } from '@kistler/skybase-oauth'

import { createAppReducer } from '../reducers/reducers.js'
import { history } from './history.js'

export const createAppStore = (initialState = {}) =>
  configureStore({
    preloadedState: initialState,
    reducer: enableBatching(createAppReducer(history)),
    middleware: getDefaultMiddleware => {
      const middlewares = [
        redirectMiddleware,

        ...getDefaultMiddleware({
          serializableCheck: false,
          immutableCheck: false,
        }),

        // Skybase-Middlewares
        localeMiddleware,
        downloadFileMiddleware,

        oauthMiddleware,
      ]
      if (process?.env?.NODE_ENV === 'development') {
        middlewares.push(loggerMiddleware)
      }
      return middlewares
    },
  })

const store = createAppStore()

// Set the store to the window object so, that it is accessible from the browser console only when in development
if (process?.env?.NODE_ENV === 'development') {
  window.store = store
}

export default store
